<template>
  <div class="shop-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="店长二维码"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!-- 详情 -->
    <template v-if="detail">
    <div>

      <div class="van-cell-group van-hairline--top-bottom van-panel" style="margin-bottom: 6px; font-size: 12px;">
        <div class="van-cell van-panel__header">
          <div>
            <img :src="detail.qrimg" alt="" style="width: 100%;">
          </div>
        </div>
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span style="float: left;">{{detail.title}}</span>
            <span style="float: right;">{{detail.coordinate}}</span>
            <div class="van-cell__label" style="clear: both;">{{detail.province+detail.city+detail.district+detail.address}}</div>
          </div>
        </div>
        <div class="van-cell van-panel__header dk-header-after">
          <div class="van-cell__title">
            <span style="float: left;">咨询电话：{{detail.phone}}</span>
          </div>
        </div>
        <div class="van-panel__content"></div>
        <div class="van-panel__footer van-hairline--top dk-footer-after">
          <button class="van-button van-button--info van-button--small" @click="getTel(detail.phone)">
            <div class="van-button__content">
              <span class="van-button__text">立即拨打</span>
            </div>
          </button>
          <button class="van-button van-button--info van-button--small" style="margin-left: 10px;" @click="getUrl(detail.map_url)">
            <div class="van-button__content">
              <span class="van-button__text">地图导航</span>
            </div>
          </button>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom van-panel" style="font-size: 12px;">
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span v-html="detail.content"></span>
          </div>
        </div>
        <div class="van-panel__content"></div>
      </div>

    </div>
    </template>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'ShopList',
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            detail: state => state.shop.shop_detail.data,
            lng: state => state.cityData.lng,
            lat: state => state.cityData.lat
        })
    },
    methods: {
      ...mapActions(['requestShopDetail']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        getTel(val) {
           return window.location.href = 'tel:'+val
        },
        getUrl(val) {
           return window.location.href = val
        },
        onClickLeft() {
            this.$router.push({path: '/shop/list'});
        }
    },
    components: {

    },
    mounted() {
        this.requestShopDetail({"thit":this,"id":this.$route.params.id,"lnglat":this.lng+","+this.lat});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.shop-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.shop-list >>> .van-nav-bar__text {
  color: #fff;
}
.shop-list >>> .van-nav-bar__title {
  color: #fff;
}
.shop-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.shop-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
